import React from 'react';
import styled, { css } from 'styled-components';

import NotificationBtn from '@template/Notifications/NotificationBtn';
import { masterSet } from '@masterSetting/masterSet/masterSetting';
import ChatBtn from '@pages/Chat/ChatBtn';
import MusicButton from '@template/MusicPlayer/MusicBtn';
import WalletPrice from '@pages/Store/component/WalletPrice';
import LoginUserSec from '@components/navigation/common/LoginUserSec';
import { IPhotoCard } from '@typings/photocard/photocard.interface';
import { CHAR_PANEL_TYPE } from '@typings/menu/charPanelType';
import ActionButtons from './ActionButtons';
import { useRecoilValue } from 'recoil';
import useToggle from '@hooks/useToggle';
import { homeSettingState } from '@atom/setting/homeSettingState';
import { currentUserIDState } from '@atom/setting/user';
import { IhomepageSetting } from '@typings/setting/homepageSetting.interface';
import { mainPhotocardDataState } from '@atom/setting/photocardAutoSetState';
import useWindowWidth from '@hooks/useWindowWidth';

const BtnWrap = styled.div`
  position: fixed;
  top: 32px;
  right: 100px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: fit-content;
  z-index: 4;

  @media (max-width: 480px) {
    top: 56px;
    left: 6px;
  }
`;

const FrontBtnWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  justify-content: flex-end;

  @media (max-width: 480px) {
    padding: 6px 12px;
  }
`;


function CharacterFuncSec() {


  return (
    <BtnWrap>
      <FrontBtnWrap>

        <MusicButton color="var(--menuTextColor)" />
        <NotificationBtn
          dropdownDir="topRight"
          color="var(--menuTextColor)"
        />
        {masterSet.chat && <ChatBtn color="var(--menuTextColor)" />}
        <LoginUserSec />
      </FrontBtnWrap>

    </BtnWrap>
  );
}

export default CharacterFuncSec;